import { gql } from '@provision/graphql-client';
import { AUTO_GENERATE_SITE_DOCS_FRAGMENT } from './auto-generate-site-docs.operations.fragments';

export const AUTO_GENERATE_SITE_DOCS_MUTATION = gql`
  mutation AutogenerateSiteDocs($params: AutogenerateSiteDocsInput!) {
    autogenerateSiteDocs(params: $params) {
      ...AutoGenerateSiteDocsFields
    }
  }
  ${AUTO_GENERATE_SITE_DOCS_FRAGMENT}
`;
